var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioCenterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00FFAA;opacity:0;}.cls-2{fill:#00FFAA;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "radio") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "radio"
  }, /*#__PURE__*/React.createElement("g", {
    id: "radio-2",
    "data-name": "radio"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12,8a3,3,0,0,0-1,5.83A1,1,0,0,0,11,14v6a1,1,0,0,0,2,0V14a1,1,0,0,0,0-.17A3,3,0,0,0,12,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.5,11A6.87,6.87,0,0,1,6.14,5.77,1,1,0,1,0,4.86,4.23,8.84,8.84,0,0,0,1.5,11a8.84,8.84,0,0,0,3.36,6.77,1,1,0,1,0,1.28-1.54A6.87,6.87,0,0,1,3.5,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.64,6.24a1,1,0,0,0-1.28,1.52A4.28,4.28,0,0,1,17,11a4.28,4.28,0,0,1-1.64,3.24A1,1,0,0,0,16,16a1,1,0,0,0,.64-.24A6.2,6.2,0,0,0,19,11,6.2,6.2,0,0,0,16.64,6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.76,6.36a1,1,0,0,0-1.4-.12A6.2,6.2,0,0,0,5,11a6.2,6.2,0,0,0,2.36,4.76,1,1,0,0,0,1.4-.12,1,1,0,0,0-.12-1.4A4.28,4.28,0,0,1,7,11,4.28,4.28,0,0,1,8.64,7.76,1,1,0,0,0,8.76,6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.14,4.23a1,1,0,1,0-1.28,1.54A6.87,6.87,0,0,1,20.5,11a6.87,6.87,0,0,1-2.64,5.23,1,1,0,0,0,1.28,1.54A8.84,8.84,0,0,0,22.5,11,8.84,8.84,0,0,0,19.14,4.23Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioCenterIcon);
export default __webpack_public_path__ + "static/media/radio-center-icon.27a59867c0bdf5f7d25a604639f686c4.svg";
export { ForwardRef as ReactComponent };